import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    authVisible: false,
    category: "everything"
  },
  mutations: {
    setAuthVisible(state, value) {
      state.authVisible = value;
    },
    setCategory(state, value) {
      state.category = value
    }
  },
  actions: {
    setAuthVisible({ commit }, visible) {
      commit("setAuthVisible", visible);
    },
    setCategory({ commit }, category) {
      commit("setCategory", category);
    }
  },
  getters: {
    authVisible: initialState => {
      return initialState.authVisible;
    },
    category: initialState => {
      return initialState.category;
    }
  },
  modules: {}
});
